import { useFetch } from "../../hooks/useFetch";

export const FetchAssetsList = async (query) => {
  try {
    const data = await useFetch(
      `${process.env.REACT_APP_API_URL}/assets`,
      query
    );

    return data.data;
  } catch (err) {
    console.log(err, "error");
    return null;
  }
};
